import { Link } from 'react-router-dom'

import styles from './NotFound.module.css'

export default function NotFoundPage() {
  return (
    <div className={styles.page}>
      <div className={styles.topLine} />
      <div className={styles.cornerTL} />
      <div className={styles.cornerBR} />

      <div className={styles.container}>
        <div className={styles.numberBlock}>
          <span className={styles.number}>404</span>
        </div>

        <div className={styles.divider} />

        <div className={styles.textBlock}>
          <span className={styles.label}>Página não encontrada</span>
          <h1 className={styles.title}>Parece que essa página não faz parte do acervo.</h1>
          <p className={styles.description}>
            O endereço que você tentou acessar não existe ou foi movido. Volte para o início e continue navegando.
          </p>
          <Link to="/home" className={styles.link}>
            <span className={styles.linkArrow}>&larr;</span>
            Voltar ao início
          </Link>
        </div>
      </div>

      <span className={styles.footer}>ABRA &mdash; Academia Brasileira de Artes</span>
    </div>
  )
}
